import { Observable } from 'rxjs';

import { PassiveSpeaker } from './models';

export abstract class CoverageAudioPassiveSpeakerApiService {
	public abstract getAudioChannelPassiveSpeaker$(passiveSpeakerId: string): Observable<PassiveSpeaker>;
}
